"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const app_module_1 = require("./app/app.module");
const environment_1 = require("../../service-lib/src/lib/environment");
const common_bootstrap_1 = require("../../service-lib/src/lib/common-bootstrap"); //import global bootstrap setup from service-lib
async function bootstrap() {
    const commonBootstrap = new common_bootstrap_1.CommonBootstrap();
    const gatewayUrl = environment_1.ENV.URL_API_GATEWAY;
    const port = environment_1.ENV.PORT_AUTH_SERVICE ? parseInt(environment_1.ENV.PORT_AUTH_SERVICE, 10) : 3003;
    await commonBootstrap.bootstrap(port, app_module_1.AppModule, 'Auth Service', gatewayUrl, 'auth-service');
}
bootstrap();
